import { NativeElement2p8z5z0r9meck as NativeElement } from '../NativeElement.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SpaceClass;
function Space() {
  if (SpaceClass === VOID) {
    class $ extends NativeElement() {
      constructor(context, multiplier) {
        multiplier = multiplier === VOID ? 1.0 : multiplier;
        super(context);
        this.native_1.tag_1 = 'span';
        this.native_1.classes_1.add_utx5q5_k$('kiteui-space');
        this.native_1.setStyleProperty_wavvb3_k$('--space-multiplier', multiplier.toString());
      }
    }
    initMetadataForClass($, 'Space');
    SpaceClass = $;
  }
  return SpaceClass;
}
//region block: exports
export {
  Space as Spaceoq5xo9lsieqc,
};
//endregion

//# sourceMappingURL=Space.commonHtml.mjs.map
